import React, { Component } from  'react'
import mediaFiles from '../../../../../apis/wpApi/mediaFiles'
import Button from '../../../../general/Button'
import ImageDisplayAndDelete from '../ImagesDisplayAndDelete'

class ImageDisplayDeleteAndUpload extends Component {
    constructor(props) {
        super(props)

        this.onUploadEndSuccess = this.onUploadEndSuccess.bind(this)
        this.onUploadEndError = this.onUploadEndError.bind(this)
    }

    formatDataObj(data) {
        const { id, url, alt, format } = data

        return {
            id: parseInt(id),
            source_url: url,
            alt_text: alt,
            format: format
        }
    }

    onUploadStart() {
        const { onUploadStart, image, imageType, movieTitle } = this.props
        let sizeQuery = ''
        if(image.url && (image.url.search("orchestrationlayer.cloudticket.net") !== -1 || image.url.search("cineorder-content-uat.cloudticket.net") !== -1 ||image.url.search("contentservice.cineorder.shop") !== -1)) {
            if(imageType === 'backgrounds' || imageType === 'ambient') {
                sizeQuery = "&size=2000"
            } else {
                sizeQuery = "&size=400"
            }
        }    

        const imageUrl = image.url + sizeQuery
        onUploadStart()

        mediaFiles.createByUrl(
            movieTitle,
            imageType,
            imageUrl,
            this.onUploadEndSuccess, 
            this.onUploadEndError
        )
    }

    onUploadEndSuccess(data) {
        const { replaceUploadAt, onUploadEndSuccess } = this.props

        const formatedData = this.formatDataObj(data)

        if(false === replaceUploadAt) {
            onUploadEndSuccess(formatedData)
        } else {
            onUploadEndSuccess(formatedData, replaceUploadAt)
        }
    }

    onUploadEndError(error) {
        const { onUploadEndError } = this.props

        onUploadEndError(error)
    }


    render() {

        const { field, index, image, isDisabled, onDeleteImage, imagePosition, imageType, imagePositionX } = this.props

        return (
            <div>
                <ImageDisplayAndDelete
                    field={field}
                    index={index}
                    imageType={imageType}
                    image={image}
                    imagePositionX={imagePositionX}
                    onDeleteImage={onDeleteImage}
                    imagePosition={imagePosition}
                />

                <Button
                    className="images-upload-button-local"
                    transId={'images_uploads_upload_local'}
                    onClick={() => this.onUploadStart()}
                    hideText={false}
                    disabled={isDisabled}
                />
            </div>
        )
    }
    
}

export default ImageDisplayDeleteAndUpload